import { useState } from "react";
import { X } from "lucide-react";

const KEY = "cursus_announcement_dismissed_v1";

// Read sessionStorage on FIRST render (lazy initializer) — prevents layout shift
// from useState(false) → useEffect setVisible(true) pattern
function getInitialVisibility() {
    if (typeof window === "undefined") return true;
    try {
        return !window.sessionStorage.getItem(KEY);
    } catch {
        return true;
    }
}

export default function AnnouncementBar() {
    const [visible, setVisible] = useState(getInitialVisibility);

    if (!visible) return null;

    const dismiss = () => {
        try {
            window.sessionStorage.setItem(KEY, "1");
        } catch {
            /* noop */
        }
        setVisible(false);
    };

    return (
        <div
            data-testid="announcement-bar"
            className="relative bg-brand-ink text-white"
        >
            <div className="mx-auto flex h-9 max-w-7xl items-center justify-between gap-3 px-3 text-[10px] tracking-wide sm:h-10 sm:gap-4 sm:px-6 sm:text-[11px]">
                <div className="flex flex-1 items-center justify-center gap-2 overflow-hidden text-center">
                    <span className="hidden h-1.5 w-1.5 shrink-0 rounded-full bg-brand-orange sm:inline-block" />
                    <span className="truncate uppercase text-white/85">
                        {/* Mobile (< sm) : version courte */}
                        <span className="sm:hidden">
                            Référencé{" "}
                            <span className="font-semibold text-brand-orange">FIF PL &amp; DPC</span>
                        </span>
                        {/* Desktop (≥ sm) : version complète */}
                        <span className="hidden sm:inline">
                            L&apos;Institut de la Prévention Active · Référencé{" "}
                            <span className="font-semibold text-brand-orange">FIF PL &amp; DPC</span>
                        </span>
                    </span>
                </div>
                <button
                    type="button"
                    onClick={dismiss}
                    aria-label="Fermer le bandeau"
                    data-testid="announcement-bar-close"
                    className="flex shrink-0 items-center justify-center rounded-full p-1 text-white/60 transition-colors hover:text-white"
                >
                    <X className="h-3.5 w-3.5" />
                </button>
            </div>
        </div>
    );
}
